import React, { useState } from 'react';
import {
  Box,
  Button,
  SplitLoginLayout,
  Layout,
  Text,
  ExtInput,
  Spacer,
} from '@flexisaf/flexibull2';
import styled from 'styled-components';
import OrgSearch from 'assets/images/OrgSearch.svg';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { Notify } from '@flexisaf/flexibull2/build/notify';
import urls from 'utils/config';
import request from 'utils/request';
import Theme from 'utils/theme';
import { version } from 'version';
import { networkErrorHandler } from 'utils/errrorHandlers';
const { API_BASE_URL } = urls || {};

export const LoginWrapper = styled.div`
  height: 100%;
  width: 100%;
  & .flexi-login-splitlayout {
    min-width: 100%;
    & .flexi-login-left {
      border-radius: 0 0 45px 0;
      box-shadow: none;
      & img {
        border-radius: 15px 0 15px 0;
        width: 90%;
        /* transform: translate(30px, 20px); */
      }
    }
    & .flexi-login-right {
      box-shadow: none;
      background: linear-gradient(to bottom, #fff, ${Theme.PrimaryFade});
      & .flexi-login-right-top {
        & img {
          height: 100%;
          max-height: 100px;
        }
      }
    }
  }

  .reset-it {
    cursor: pointer;
  }
`;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Enter New Password')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/,
      'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character e.g @,#'
    ),
  confirm_password: Yup.string()
    .required('Confirm New Password')
    .when('password', {
      is: (val) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf(
        [Yup.ref('password')],
        'Confirm password does not match password'
      ),
    }),
});
export default function ResetPassword() {
  const [resetting, setResetting] = useState(false);
  const { params } = useRouteMatch();
  const history = useHistory();
  const query = useQuery();

  const formik = useFormik({
    initialValues: {
      password: '',
      confirm_password: '',
    },
    onSubmit: async () => {
      const url = `${API_BASE_URL}/ums/password/reset`;
      const data = {
        organisation: params.orgName,
        userId: query.get('user'),
        password: formik.values.password,
        token: query.get('token'),
      };

      setResetting(true);
      try {
        const response = await request({ method: 'post', data, url });
        if (response.success) {
          Notify('Password changed successfully', {
            position: 'top-right',
            status: 'success',
          });
          return history.push(`/${params.orgName}/`);
        }
        
        networkErrorHandler(response?.statusCode, response?.message);
      } catch (error) {
        Notify('Unable to reset users password', { status: 'error' });
      } finally {
        setResetting(false);
      }
    },
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: validationSchema,
  });

  const onEnter = (e) => {
    e.stopPropagation();

    if (e.key === 'Enter') {
      formik.handleSubmit();
    }
  };

  return (
    <Layout theme={Theme} showHeader={false} showFooter={false}>
      <LoginWrapper>
        <SplitLoginLayout
          image={OrgSearch}
          leftFoot={
            <Box>
              <Text>
                Copyright &copy; {new Date().getFullYear()}{' '}
                <strong>Safapply.</strong> All rights reserved.
              </Text>
            </Box>
          }
          rightTop={
            <Text>
              Welcome to <strong>{params.orgName}</strong>
            </Text>
          }
          rightFoot={
            <Box>
              <Text block>Version {version}</Text>
              <Box>
                Powered by{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://safapply.com/"
                >
                  SAFApply
                </a>{' '}
                a product of{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://flexisaf.com/"
                >
                  Flexisaf
                </a>
              </Box>
            </Box>
          }
        >
          <Box>
            <Text bold size="22px">
              Create new password
            </Text>
            <Box height="1rem" />
            <Text>
              {' '}
              Your Password reset was successful, create a new password you will
              be able to remember to continue.
            </Text>
            <Spacer />
            <form onSubmit={formik.handleSubmit}>
              <Box>
                <ExtInput
                  label="New Password"
                  type="password"
                  autocomplete="random"
                  onKeyPress={onEnter}
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={formik.errors.password}
                  required
                />
                <Text
                  color={({ theme }) => theme.PrimaryRed}
                  style={{ fontStyle: 'italic' }}
                >
                  {formik.errors.password}
                </Text>
              </Box>

              <Box>
                <ExtInput
                  label="Confirm new Password"
                  type="password"
                  autocomplete="random"
                  onKeyPress={onEnter}
                  spaceBottom="2rem"
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  error={formik.errors.confirm_password}
                  required
                />
                <Text
                  color={({ theme }) => theme.PrimaryRed}
                  style={{ fontStyle: 'italic' }}
                >
                  {formik.errors.confirm_password}
                </Text>
              </Box>

              <Box
                // }}
                align="right"
                pad="20px 0 0 0"
              >
                <Button
                  spaceLeft="auto"
                  elevate="high"
                  height={46}
                  width={200}
                  pad="0 0 0 35px"
                  block
                  progress={resetting}
                  iconRight={<i className="saf-right-open" />}
                  onClick={formik.handleSubmit}
                >
                  Change Password
                </Button>
              </Box>
            </form>
          </Box>
        </SplitLoginLayout>
      </LoginWrapper>
    </Layout>
  );
}
